import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import { Actions, ActionTypes } from '../../store/cabinet-positions/cabinet-positions.actions';
import { StateInterface } from '../../store/state.model';
import { HeadersHelper, ItemsHelper } from '../../helpers';
import { _, tassign, getState } from '../../tools';

import 'rxjs/Rx';

@Injectable()

/**
 * Class representing the CabinetPositions service.
 */
export class CabinetPositionsService {

	/**
	 * Constructor.
	 * @param {string} apiEndPoint
	 * @param {Http} http
	 * @param {Store} store
	 * @return {void}
	 */
	constructor(
		@Inject('ApiEndpoint') private apiEndpoint: string,
		private http: Http,
		private store: Store<StateInterface>) {
	}

	/**
	 * Retrieve cabinets data from server and dispatch action
	 * to update the store accordingly.
	 * @return {Observable}
	 */
	hydrateCabinetPositions(): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		return this.http
			.get(`${this.apiEndpoint}cabinetPosition`, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Dispatch an action to load cabinet positions.
	 * @param {object} result
	 * @return {Actions}
	 */
	loadCabinetPositions(result: any): Actions {
		const { cabinetPositions } = getState(this.store);

		return {
			type: ActionTypes.LOAD_CABINET_POSITIONS,
			payload: tassign(cabinetPositions, {
				items: ItemsHelper.mapCabinetPositionItems(result),
				isLoading: false
			})
		};
	}

	/**
	 * Retrieve cabinets data from server and dispatch action
	 * to update the store accordingly.
	 * @return {Observable}
	 */
	setCabinetPositionRecipe(cabinetPositionId: number, recipeId?: number): Observable<Response> {
		this.store.dispatch(this.setIsLoading(true));
		return this.http
			.patch(`${this.apiEndpoint}cabinetPosition/` + cabinetPositionId, {
				RecipeID: recipeId || -1
			}, HeadersHelper.getOptions(this.store));
	}

	/**
	 * Dispatch an action to reset the entire state.
	 * @return {Actions}
	 */
	resetState(): Actions {
		return {
			type: ActionTypes.RESET_STATE
		};
	}

	/**
	 * Dispatch an action to change the state for 'isLoading'.
	 * @param {boolean} to - The new state
	 * @return {Actions}
	 */
	setIsLoading(to: boolean): Actions {
		return {
			type: ActionTypes.SET_IS_LOADING,
			payload: to
		};
	}
}
